module.exports = __webpack_public_path__ + "img/logo-floridapolitechnic-dark.99e1508b.svg";